import { createAsyncThunk } from '@reduxjs/toolkit';
import locationApi from '~/apis/location';
import { IParamsGetLocation, IResponseGetLocation } from '~/utils/interface/location';

export const handleGetLocationList = createAsyncThunk<IResponseGetLocation, IParamsGetLocation>(
  'GET_LOCATION_LIST',
  async (params: IParamsGetLocation = {}, { rejectWithValue }) => {
    try {
      const res = await locationApi.getList(params);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
